module.exports = __webpack_public_path__ + "img/sign-78.5b6c833e.jpg";